var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "placeholder",
    height: "32px",
    viewBox: "0 -960 960 960",
    width: "32px",
    fill: "color-mix(in srgb, #009fe3, #fff 50%)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n    .placeholder { transform-origin: 480px -480px; animation: pulse 0.5s ease infinite; }\r\n    @keyframes pulse { \r\n      0% { transform: scale(0.5); opacity: 0; }\r\n      50% { transform: scale(1); opacity: 0.5; }\r\n      100% { transform: scale(0.5); opacity: 0; }\r\n    }\r\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "placeholder",
    d: "M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.44eb7ece3728e6d6dbb94d3c206063e0.svg";
export { ForwardRef as ReactComponent };